<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Graphics-break"><img alt="" class="_idGenObjectAttribute-1" src="image/9781528954297_tp.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528954297_EPUB-1.vue?246a8d72